import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Player } from 'video-react';
import moment from 'moment';

import { FlightCardListSmall } from '../FlightCardList/FlightCardList';

import Carousel from 'nuka-carousel';

import styles from './FlightsHome.module.css';

import sydneyVid from './video/sydney.mov';
import sydneyPoster from './video/sydney-poster.jpg';

import sbVid from './video/sb.mov';
import sbPoster from './video/sb-poster.jpg';

const cx = classNames.bind(styles);

// truncate code for sanity's sake
const flightDates = [
  {
    day: 'M',
    number: 1,
    price: 229
  },
  {
    day: 'T',
    number: 2,
    price: 229
  },
  {
    day: 'W',
    number: 3,
    price: 229
  },
  {
    day: 'T',
    number: 4,
    price: 229
  },
  {
    day: 'F',
    number: 5,
    price: 229
  },
  {
    day: 'S',
    number: 6,
    price: 229
  },
  {
    day: 'S',
    number: 7,
    price: 229
  },
  {
    day: 'M',
    number: 8,
    price: 229
  },
  {
    day: 'T',
    number: 9,
    price: 229
  },
  {
    day: 'W',
    number: 10,
    price: 229
  },
  {
    day: 'T',
    number: 11,
    price: 229
  },
  {
    day: 'F',
    number: 12,
    price: 229
  },
  {
    day: 'S',
    number: 13,
    price: 229
  },
  {
    day: 'S',
    number: 14,
    price: 229
  },
  {
    day: 'M',
    number: 15,
    price: 229
  },
  {
    day: 'T',
    number: 16,
    price: 229
  },
  {
    day: 'W',
    number: 17,
    price: 229
  },
  {
    day: 'T',
    number: 18,
    price: 229
  },
  {
    day: 'F',
    number: 19,
    price: 229
  },
  {
    day: 'S',
    number: 20,
    price: 229
  },
  {
    day: 'S',
    number: 21,
    price: 229
  },
  {
    day: 'M',
    number: 22,
    price: 229
  },
  {
    day: 'T',
    number: 23,
    price: 229
  },
  {
    day: 'W',
    number: 24,
    price: 229
  },
  {
    day: 'T',
    number: 25,
    price: 229
  },
  {
    day: 'F',
    number: 26,
    price: 229
  },
  {
    day: 'S',
    number: 27,
    price: 229
  },
  {
    day: 'S',
    number: 28,
    price: 229
  },
  {
    day: 'M',
    number: 29,
    price: 229
  },
  {
    day: 'T',
    number: 30,
    price: 229
  },
  {
    day: 'W',
    number: 31,
    price: 229
  },
];

const tipsLongHaul = [
  {
    image: require('./img/tip-1.png'),
    description: "Sydney's short fall season and perfect weather is a sweet spot for tourists."
  },
  {
    image: require('./img/tip-2.jpeg'),
    description: "Australia is home to the world's oldest continuous cultures, the Eora Nation."
  },
  {
    image: require('./img/tip-3.jpeg'),
    description: "From Palm Beach and Manly to the famous Bondi and Coogee, Sydney has a beach for everyone."
  },
  {
    image: require('./img/tip-4.jpeg'),
    description: "Visit the Blue Mountains to see rock formations and hike many trails for views of rock walls, waterfalls, and more."
  },
  {
    image: require('./img/tip-5.jpeg'),
    description: "North of town is one of Australia's premier wine regions. The Hunter Valley is home to amazing wineries that produce luscious reds."
  }
]

const tipsShortHaul = [
  {
    image: require('./img/sb_tip1.jpg'),
    description: "The best time to visit Santa Barbara is from March to May or from September to November. "
  },
  {
    image: require('./img/sb_tip2.jpg'),
    description: "The Santa Barbara zoo has been ranked numerous times as one of the nation's best small zoos."
  },
  {
    image: require('./img/sb_tip3.jpg'),
    description: "Most visitors come to Santa Barbara to relax along the serene beaches."
  },
  {
    image: require('./img/sb_tip4.jpg'),
    description: "Fresh local produce is a staple in Santa Barbara, thanks to a climate that's conducive to a year-round growing season."
  },
  {
    image: require('./img/sb_tip5.jpg'),
    description: "Santa Barbara sees an average of 300+ days of sunshine every year."
  },
]

const eventsLongHaul = [
  {
    image: require('./img/event-1.jpg'),
    name: 'Vivid Sydney',
    description: 'Watch the entire city come to life for this music festival with bright lights and creative ideas.',
    price: 159
  },
  {
    image: require('./img/event-2.jpg'),
    name: 'L’Étape Australia',
    description: 'The first Tour de France event to be held in Australia, L’Étape Australia is a semi-professional cycling event run for amateurs.',
    price: 159
  },
  {
    image: require('./img/event-3.jpg'),
    name: 'Carriageworks Farmers Market',
    description: 'An award-winning authentic Farmers Market held every Saturday in the heart of Refern in Sydney.',
    price: 159
  },
  {
    image: require('./img/event-4.jpg'),
    name: 'Seven Peaks Walk',
    description: 'Lord How’s premier five day guided adventure that takes you from pristine beaches and exposed coral platform  to delicate mist forests.',
    price: 159
  }
]

const eventsShortHaul = [
  {
    image: require('./img/flower_event.jpg'),
    name: 'SEPTEMBER',
    description: 'The 74th International Orchid Show ',
    price: 159
  },
  {
    image: require('./img/craft_brew_event.jpg'),
    name: 'OCTOBER',
    description: '1st Annual Craft Brew Week',
    price: 159
  },
  {
    image: require('./img/flower_event.jpg'),
    name: 'SEPTEMBER',
    description: 'The 74th International Orchid Show ',
    price: 159
  },
  {
    image: require('./img/craft_brew_event.jpg'),
    name: 'OCTOBER',
    description: '1st Annual Craft Brew Week',
    price: 159
  },

]


class FlightsHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStripIndex: 0,
      activeDotIndex: 0,
      selectedDateId: null,
    };

    this.onSelectDate = this.onSelectDate.bind(this);
  }
  
  onSelectDate(selectedDateId, month, date) {
    const startDate = new moment(`${month} ${date}`);
    this.props.setStartDate(startDate);
    this.setState({ selectedDateId });
  }

  render() {

    const activeVideo = this.props.isLongHaul ? sydneyVid : sbVid;
    const activePoster = this.props.isLongHaul ? sydneyPoster : sbPoster;
    const { isLongHaul } = this.props;
    const component = this;

    const flightsHomePricesEmphasized = cx({
      emphasizedBarLight: !isLongHaul,
      emphasizedBarDark: isLongHaul
    })

    const getDateStyle = id => cx({
      flightsHomeDatesContainer: true,
      selected: this.state.selectedDateId === id,
    });

    let events = isLongHaul ? eventsLongHaul : eventsShortHaul;
    events = events.map((event, index) => {
      return (
        <div key={index} className={styles.flightsHomeEventsContainer}>
          <div className={styles.flightsHomeEventsGradient}/>
          {/* <h5>UPCOMING EVENTS IN SYDNEY</h5> */}
          <img src={event.image} alt="" />

          <div className={styles.flightsHomeEventsInfoContainer}>
            <h1>{event.name}</h1>
            <h4>{event.description}</h4>
            {/* <p>Starting from <span>${event.price}</span></p> */}
          </div>
        </div>
      )
    });

    const tips = isLongHaul ? tipsLongHaul : tipsShortHaul;

    const eventContainerStyles = cx({
      flightsHomeEventsContainer:true,
      flightsHomeEventsContainerShort: !isLongHaul
    });

    return (
      <div className={styles.flightsPageWrapper}>
       
        <div className={styles.videoPlayer}>
          <div className={styles.videoPlayerGradient}/>
          <Player
            playsInline
            preload={'auto'}
            fluid={false}
            autoPlay
            loop
            height={495}
            width={375}
            muted
            poster={activePoster}
            src={activeVideo}
          />
        </div>
        
        <div className={styles.flightsHomeIntro}>
          {isLongHaul ? <p>SYDNEY, AUSTRALIA </p> : <p>SANTA BARBARA </p>}
          {isLongHaul ? <h3 style={{width: 250}}>The Harbour City</h3> : <h3>Close to home coastal charm</h3>}
        </div>

        {isLongHaul ? <div><br/><br/></div> : null}

        <div style={{marginTop: !isLongHaul ? 48 : 0}} className={styles.flightsHomeDates}>
          <h3>Add flight dates</h3>
          <p>July 2018</p>

          <div className={styles.flightsHomeDatesWrapper}>
            <div className={styles.flightsHomeDateScroller}>
              {flightDates.map((date, index) =>{
                return (
                  <div onClick={() => this.onSelectDate(index, 'july', date.number)} key={`date-${index}`} className={getDateStyle(index)}>
                      <p className={styles.flightsHomeDatesDay}>{date.day}</p>
                      <p className={styles.flightsHomeDatesNumber}>{date.number}</p>
                      <p className={styles.flightsHomeDatesPrice} style={{color: date.number === 5 || date.number === 12 || date.number === 19 || date.number === 26 ? '#008489' : '#BDBDBD' }}>${date.price}</p>
                  </div>
                )
              })}
            </div>
          </div>

          <Link className={styles.flightsHomeDatesButtonDark} to="/flights/calendar">{'View calendar'}</Link>
        </div>

        <div className={styles.flightsHomeSmallCards}>
          {isLongHaul ? <h3 style={{width: 200}}>Great deals in the next few months</h3> : <h3>Fly this weekend</h3>}
          <FlightCardListSmall count={3} />
          <Link className={styles.flightsHomeDatesButtonLight} to="#">{'See All'}</Link>
        </div>

        <div className={styles.flightsHomePrices}>
          <h3 style={{width: isLongHaul ? 250 : 350}}>Average prices for flights to {isLongHaul ? 'Sydney' : 'Santa Barbara'}</h3>
          <div className={styles.graph}>
            <div>
              <div className={styles.bar} style={{ height: '71px' }}></div>
              <span className={styles.price}>{isLongHaul ? '$980' : '$310'}</span>
              <h4>Jun</h4>
              <span className={styles.temp}>57°F</span>
            </div>
            <div>
              <div className={styles.bar} style={{ height: '81px' }}></div>
              <span className={styles.price}>{isLongHaul ? '$1,230' : '$350'}</span>
              <h4>Jul</h4>
              <span className={styles.temp}>55°F</span>
            </div>
            <div>
              <div className={styles.bar} style={{ height: '79px' }}></div>
              <span className={styles.price}>{isLongHaul ? '$1,200' : '$340'}</span>
              <h4>Aug</h4>
              <span className={styles.temp}>57°F</span>
            </div>
            <div className={flightsHomePricesEmphasized}>
              <div className={styles.bar} style={{ height: '54px' }}></div>
              <span className={styles.price}>{isLongHaul ? '$895' : '$210'}</span>
              <h4>Sep</h4>
              <span className={styles.temp}>61°F</span>
            </div>
            <div>
              <div className={styles.bar} style={{ height: '72px' }}></div>
              <span className={styles.price}>{isLongHaul ? '$1,100' : '$320'}</span>
              <h4>Oct</h4>
              <span className={styles.temp}>64°F</span>
            </div>
            <div className={flightsHomePricesEmphasized }>
              <div className={styles.bar} style={{ height: '61px' }}></div>
              <span className={styles.price}>{isLongHaul ? '$1,000' : '$230'}</span>
              <h4>Nov</h4>
              <span className={styles.temp}>68°F</span>
            </div>
          </div>
        </div>


        {/* Start Tips Carousel */}
        <div>
          <Carousel
            afterSlide={(index) => { component.setState({ activeStripIndex: index}) }}
            renderBottomCenterControls={() => ('')}
            style={{height: 600}}>
            {tips.map((tip, index) => {
              return (
                <div key={index} className={styles.flightsHomeTipsContainer}>
                  <div className={styles.flightsHomeTripsGradient}/>
                  <img src={tip.image} alt="" />
                  <div className={styles.flightsHomeTipsInfoContainer}>
                    <p>{isLongHaul ? 'SYDNEY TIPS' : 'SANTA BARBARA TIPS'}</p>
                    <h4>{tip.description}</h4>
                  </div>
                </div>
              )
            })}
          </Carousel>
          <div className={styles.flightsHomeTipsDecorators}>
            {tips.map((event, i) => {
              return (
                <div
                 className={styles.flightsHomeDecorator}
                 key={i}
                 style={{backgroundColor: (component.state.activeStripIndex === i) ? 'white' : '#C4C4C4', opacity: (component.state.activeStripIndex === i) ? 1 : 0.3}}/>
              )
            })}
          </div>
        </div>
        {/* End Tips Carousel */}



        {/* Start Short haul events carousel */}
        { !isLongHaul ?
          <div>
            <h5 className={styles.eventsHeaderShort}>Upcoming events in <br />Santa Barbara</h5>
            <Carousel
              afterSlide={(index) => { component.setState({ activeDotIndex: index}) }}
              renderBottomCenterControls={() => ('')}
              slidesToShow={2}
              style={{height: 330}}>
              {eventsShortHaul.map((event, index) => {
                return (
                  <div key={index} className={eventContainerStyles}>
                    
                    <img src={event.image} alt="" />

                    <div className={styles.flightsHomeEventsInfoContainer}>
                      <h1>{event.name}</h1>
                      <h4>{event.description}</h4>

                      <p>Flights from <span>${event.price}</span></p>
                    </div>
                  </div>
                )
              })}
            </Carousel>
            <div className={styles.showMoreWrapper}>
              <Link className={styles.flightsHomeDatesButtonLight} to="#">{'Show More'}</Link>
            </div>
            <hr />
          </div>
        : null }
        {/* End Short haul events carousel */}


        <div className={styles.flightsHomeLinkGrid}>
          <h3 style={{width: isLongHaul ? 220 : 300, paddingBottom: isLongHaul ? 10 : 0 }}>{isLongHaul ? 'Destinations' : 'Destination'} similar to {isLongHaul ? 'Sydney, Australia' : 'Santa Barbara'}</h3>
          <div className={styles.destinations}>

            <Link to={`/flights`} className={styles.destination}>
              <img style={{borderRadius: isLongHaul ? 4 : 0}} src={require(isLongHaul ? './img/montreal.jpeg' : './img/similar-0.jpg')} alt="" />
              <h4>{isLongHaul ? 'Montreal' : 'Monterey'}</h4>
              <p>Flights from $230</p>
            </Link>

            <Link to={`/flights`} className={styles.destination}>
              <img style={{borderRadius: isLongHaul ? 4 : 0}} src={require(isLongHaul ? './img/cape-town.jpeg' : './img/similar-1.jpg')} alt="" />
              <h4>{isLongHaul ? 'Cape Town' : 'Palm Springs'}</h4>
              <p>Flights from $299</p>
            </Link>

            <Link to={`/flights`} className={styles.destination}>
              <img style={{borderRadius: isLongHaul ? 4 : 0}} src={require(isLongHaul ? './img/boston.jpeg' : './img/similar-2.jpg')} alt="" />
              <h4>{isLongHaul ? 'Boston' : 'Napa Valley'}</h4>
              <p>Flights from $230</p>
            </Link>

            <Link to={`/flights`} className={styles.destination}>
              <img style={{borderRadius: isLongHaul ? 4 : 0}} src={require(isLongHaul ? './img/new-orleans.jpeg' : './img/similar-3.jpg')} alt="" />
              <h4>{isLongHaul ? 'New Orleans' : 'Tahoe'}</h4>
              <p>Flights from $200</p>
            </Link>

          </div>
        </div>
        

        {/* Start Long Haul events carousel */}
        {isLongHaul ?
          <div className={styles.eventCarouselWrapper}>
            <Carousel
              afterSlide={(index) => { component.setState({ activeDotIndex: index}) }}
              renderBottomCenterControls={() => ('')}
              style={{height: 590}}
            >
              {events}
            </Carousel>
            <div className={styles.flightsHomeEventsOverlayContainer} >
              <p>Starting from <span>$159</span></p>
              <h5>UPCOMING EVENTS IN SYDNEY</h5>
            </div>
            <div className={styles.flightsHomeDecoratorsDots}>
              {events.map((event, i) => {
                return (
                  <div
                    className={styles.flightsHomeDecoratorDot}
                    key={i}
                    style={{ backgroundColor: (component.state.activeDotIndex === i) ? 'white' : '#C4C4C4', opacity: (component.state.activeDotIndex === i) ? 1 : 0.3 }}
                  />
                )
              })}
            </div>
          </div>
        : null }
        {/* End Long Haul events carousel */}

      </div>

    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setStartDate: data =>
      dispatch({
        type: 'SET_STARTDATE',
        payload: data,
      }),
    setEndDate: data =>
      dispatch({
        type: 'SET_ENDDATE',
        payload: data,
      }),
  };
};

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  outboundFlightData: main.outboundFlightData,
  returnFlightData: main.returnFlightData,
});


export default connect(mapStateToProps, mapDispatchToProps)(FlightsHome);



// WEBPACK FOOTER //
// ./src/components/FlightsHome/FlightsHome.jsx